// ----------------- Admin page types

// -------------------- data tables
/**
* Type for column configuration of DataTable.
*/
export type DTColumn = { title?: string
  ; name?: string
  ; searchable: boolean
  ; visible: boolean
  ; data?: number | null
  ; className?: string
  ; orderable?: boolean
  ; defaultContent?: string; 
}
/**
* Type representing the order of DataTable columns.
*/
export type DTColOrder = (string | number)[]

/**
* Type representing column options for DataTable.
*/
export type DTColumnOptions = {tColData: DTColumn[]
                                  ,tColOrder?: DTColOrder[]
                                  ,tColumnDefs?:[]
                                  ,tSearchCols?:[{} | null]
/**
* Type representing callback functions for DataTable.
*/                                }
export type DTCallbacks = {fnRowClickCallback?:(plEventID:number)=>void
  ,fnTableDrawCallback?:()=>void,
  drawbackcallback:(pbEventPending?:boolean) => boolean}
/**
* Type representing DataTable options.
*/
export type DTOptions = {sourcetable:string
  ,columns:DTColumnOptions
  ,enabletablesearch:boolean
  ,callbacks:DTCallbacks
  ,asyncprogressid?:number
}
/**
* Type for settings of DataTable events.
*/
export type DTEventSettings = {
  callbacks:DTCallbacks
  ,columnoptions:DTColumnOptions
  ,archivebuttonid:string
  ,sTableElementID: string
  ,psWrapperDivElementID: string
  ,psDefaultSearchElemID: string
  ,sourcetable:string
}

// --------------User prefs
/**
* Type representing an authenticated user.
*/
export type AuthedUser = {
  login:string
  , userid:number
  , userattributes:{
      person:any
      , state?:any
      , prefs?:any
  }
  , refresh?:number
}


/**
* Type for dialog options.
*/
export type DialogOptions = {
  buttons_always_visible?: boolean,
  scripts?: string,
  psStyles?: string,
  plLineCount?: number
  modal?: {dismissible:boolean}
  expand?: {full:boolean,generation:number}
  name?: string
}
// -------------------- System settings
/**
* Type for system update settings.
*/
export type SystemUpdate_Set = {
  services?: {[key: string]: SystemServiceEvents;};
}
/**
* Type for service-specific system update settings.
*/      
export type SystemUpdate_SetService = {
  services: [];
} 
/**
* Type for events of system services.
*/
export type SystemServiceEvents = {
  events?: [];
}

/**
* Type for service events.
*/
export type ServiceEvents = {
  events?: [];
}
/**
* Type for chart data.
*/
export  type ChartData = {allocated?:[number,number]
  ,disk?:[number,number]
  ,alloc_util?:ChartPoint[]
  ,disk_util?:ChartPoint[]
  ,disk_free?:ChartPoint[]
  ,disk_var?:ChartPoint[]
  ,count_var?:ChartPoint[]
  ,minfreespace?:number
  ,maxsize?:number
}

type ChartPoint = { x: any; y: string; src: { num: any; denom: any; }; }
// -------------------- Bugatti settings and charts

/**
* Type for Bugatti settings.
*/
export type BugattiSetting_Set = {
  devices?: {[key: string]: CameraEvents;};
  
}
/**
* Type for events of camera devices.
*/
export type CameraEvents = {
  history?: []
}  
/**
* Type for Bugatti update settings.
*/
export type BugattiUpdate_Set = {
  [key: string]: CameraEvents;
  
}

// ----------------------- JSONModal consts
/**
* Class representing a JSON object with specific methods to get its string and object representation.
*/
class JSONObject {
  private _tData: object;

  constructor(ptData: object) {
      this._tData = ptData;
  }

  asstring(pJoinObject?: object): string {
      if (pJoinObject) {
          return JSON.stringify({...this._tData, ...pJoinObject});
      } else {
          return JSON.stringify(this._tData);
      };
  }

  asobject(pJoinObject?: object): object {
      if (pJoinObject) {
          return {...this._tData, ...pJoinObject};
      } else {
          return this._tData;
      };
  }    
}


// ----------------------- MediaImage consts

/**
 * Interface representing the DefaultImages.
 * It includes an index signature along with specific properties for 'video/mpeg', 'video/mp4', and 'image/jpeg'.
 */
interface DefaultImages {
  [key: string]: string;
  'video/mpeg': string;
  'video/mp4': string;
  'image/jpeg': string;
}

/**
 * tDefaultImages is a constant of type DefaultImages.
 * It assigns specific svg file names to different media types including 'video/mpeg', 'video/mp4', and 'image/jpeg'.
 */
export const tDefaultImages: DefaultImages = {
  'video/mpeg': 'mpg.svg',
  'video/mp4': 'mpg.svg',
  'image/jpeg': 'jpg.svg'
};


// other

export type serviceImageStatus = {
  image: string;
  ttt: string;
};



export type OrbotnikColourVariant = 'magenta' | 'volcano' | 'red' | 'orange' | 'gold' | 'lime' | 'green' | 'cyan' | 'blue' | 'geekblue' | 'purple' | 'whiteongrey';
export interface ColourStyle {
  color: string;
  background: string;
  borderColor: string;
}

export const orbotnikColourByStyle: { [K in OrbotnikColourVariant]: ColourStyle } = {
  magenta: { color: '#c41d7f', background: '#fff0f6', borderColor: '#ffadd2' },
  volcano: { color: '#d4380d', background: '#fff2e8', borderColor: '#ffbb96' },
  red: { color: '#cf1322', background: '#fff1f0', borderColor: '#ffa39e' },
  orange: { color: '#d46b08', background: '#fff7e6', borderColor: '#ffd591' },
  gold: { color: '#d48806', background: '#fffbe6', borderColor: '#ffe58f' },
  lime: { color: '#7cb305', background: '#fcffe6', borderColor: '#eaff8f' },
  green: { color: '#389e0d', background: '#f6ffed', borderColor: '#b7eb8f' },
  cyan: { color: '#08979c', background: '#e6fffb', borderColor: '#87e8de' },
  blue: { color: '#0958d9', background: '#e6f4ff', borderColor: '#91caff' },
  geekblue: { color: '#1d39c4', background: '#f0f5ff', borderColor: '#adc6ff' },
  purple: { color: '#531dab', background: '#f9f0ff', borderColor: '#d3adf7' },
  whiteongrey: { color: '#6d6d6d', background: '#f5f5f5', borderColor: '#fcfcfc' },
};


export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%', 
  height: '80%', 
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto',
};   